import { Component } from '@angular/core';

import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';

import { ToasterMessage } from '@fcom/common/interfaces';
import { ToasterService } from '@fcom/common/services';
import { CartStatus, ServiceAvailability } from '@fcom/dapi';
import { FinnairCart } from '@fcom/dapi/api/models';
import { serviceAvailability, servicesReady } from '@fcom/common-booking/store/selectors';
import { BookingAppState } from '@fcom/common/interfaces/booking';

import { cartData, cartStatus } from '../../../store/selectors';
import { BookingService } from '../../../services';

@Component({
  selector: 'fin-booking-ancillaries-route',
  templateUrl: './booking-ancillaries-route.component.html',
})
export class BookingAncillariesRouteComponent {
  readonly cartData$: Observable<FinnairCart>;
  readonly cartStatus$: Observable<CartStatus>;
  readonly serviceAvailability$: Observable<ServiceAvailability>;
  readonly servicesReady$: Observable<boolean>;

  constructor(
    private bookingService: BookingService,
    private store$: Store<BookingAppState>,
    private toasterService: ToasterService
  ) {
    this.cartData$ = this.store$.pipe(cartData());
    this.cartStatus$ = this.store$.pipe(cartStatus());
    this.serviceAvailability$ = this.store$.pipe(serviceAvailability());
    this.servicesReady$ = this.store$.pipe(servicesReady());
  }

  confirmAncillaries(): void {
    this.bookingService.nextStep();
  }

  onMessage(msg: ToasterMessage): void {
    this.toasterService.addMessageToQueue(msg);
  }
}
